import { Grid } from '@mui/material';
import { SelectDropdownWidget } from 'src/components/widget';
import { useGetAllDayparts } from 'src/hooks';
import { IDaypart } from 'src/interfaces';
import { lang } from 'src/utils';

import { AssemblyStatesDaypartDropdownProps } from './AssemblyStatesDaypartDropdown.tnterface';

export const AssemblyStatesDaypartDropdown = ({
  onChangeDaypart,
  value,
}: AssemblyStatesDaypartDropdownProps) => {
  const { data: daypartData } = useGetAllDayparts();

  const onChange = (id: number) => {
    onChangeDaypart && onChangeDaypart(id);
  };

  return (
    <Grid item xs={12}>
      <SelectDropdownWidget
        label={lang.previewDaypart}
        selectOptions={daypartData?.map((value: IDaypart) => {
          return { label: value.name, value: value.id };
        })}
        value={value}
        onChange={(value) => onChange(value as number)}
      />
    </Grid>
  );
};
